import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import BaseCard from '../shared/BaseCard';
import AvatarProblem from '../shared/AvatarProblem';
import Title from '../shared/Title';
import Text from '../shared/Text';
import { breakpoints, palette } from '../../constants/styles';

const Header = styled.div`
  display: flex;
  align-items: center;
`;

const List = styled.ul`
  font-size: 1.2em;
  line-height: 23px;
  ${breakpoints.desktop} {
    font-size: 1.5em;
    line-height: 28px;
  }
`;

const Problem = styled.li`
  color: ${palette.textColor};
  margin: 0.2rem;
`;

const ProblemStyles = css`
  max-width: none;

  ${breakpoints.mobileLandscape} {
    max-width: 440px;
  }

  ${breakpoints.desktop} {
    max-width: 470px;
    // margin: 5px 20px;
  }
`;

const avatarStyles = css`
  margin: 0 10px 0 0;

  ${breakpoints.desktop} {
    width: 70px;
    height: 70px;
  }
`;

const ProblemCard = ({ name, avatar, bullets }) => (
  <BaseCard maxWidth={300} alignSelf="flex-start" styles={ProblemStyles} noBorder>
    <Header>
      <AvatarProblem src={avatar} styles={avatarStyles} />
      <Title level={5} medium>{`Conoce a ${name}`}</Title>
    </Header>
    <List>
      {bullets.map((problem, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <Problem key={`problem-${index}`}>
          <Text type="body1" styles={css`line-height: 1.4; margin: 1rem 1rem 0 0;`}>
            {problem}
          </Text>
        </Problem>
      ))}
    </List>
  </BaseCard>
);

ProblemCard.propTypes = {
  name: PropTypes.string,
  avatar: PropTypes.string,
  bullets: PropTypes.array,
};

ProblemCard.defaultProps = {
  name: '',
  avatar: '',
  bullets: [],
};

export default ProblemCard;
